angular.module('webtrader').component('doubleTouch', {
  bindings: {
    collapsed: '=',
  },
  templateUrl: BASE_URL+'templates/component.doubleTouch.html',
  controller: function (Quotes, Account, Trades) {
    this.quotes = Quotes
    this.account = Account

    this.inc = (val, add) => (typeof val !== 'number' || isNaN(val))? Math.abs(add) : Math.max((val + add).toFixed(2), Math.abs(add))
    this.volume = 1
    this.expiration = 5
    this.breakoutPrice = Quotes.currentQuote.bid
    this.targetPrice = Quotes.currentQuote.bid

    this.openTrade = () => {
      Trades.order({
        order_type: 'double_touch',
        symbol: Quotes.currentSymbol,
        volume: this.volume,
        expiration: this.expiration,
        breakout_price: this.breakoutPrice,
        target_price: this.targetPrice,
      })
    }

  }
})